import { useState } from 'react';
import { useUser } from '../../context/user';
import { Row, StyledActionBtn } from '../StandardizationProject/styles';
import CreateEditProjectModal from './CreateEditProjectModal';
import { Wrapper, Title } from './styles';
import ProjectListTable from './Table';
import { user_roles } from "../../config/enums";
import { useIdCatalogSearch } from '../SideMenuSearchLane/context';

const ProjectList = () => {
  const { user } = useUser();
  const isAdmin = user?.roles.includes(user_roles.projectAdmin) ||
      user?.roles.includes(user_roles.admin) ||
      user?.roles.includes(user_roles.castAdmin);
  const canCreateProjectIdCard = user?.roles.includes(user_roles.catalogAdmin) ||
      user?.roles.includes(user_roles.catalogProjectAdmin) ||
      user?.roles.includes(user_roles.admin) ||
      user?.roles.includes(user_roles.castAdmin);
  const [projectModal, setProjectModal] = useState({
    isOpen: false,
    project: null,
  });
  const { addCatalogItem, addProjectIdCard } = useIdCatalogSearch();

  const onEditProject = (project) => {
    setProjectModal((currentValues) => ({
      ...currentValues,
      isOpen: true,
      project,
    }));
  };

  const onProjectModalClose = () => {
    setProjectModal({
      isOpen: false,
      project: null,
    });
  };

  const onOpenProjectIdCard = (projectId) => {
    addCatalogItem(projectId, true);
  };

  const onCreateProjectIdCard = (projectId) => {
    addProjectIdCard(projectId);
  };

  const onAddProject = () => {};

  const onUpdateProject = () => {};

  const onRemoveProject = () => {};

  return (
    <>
      <Wrapper>
        <Title>Project list</Title>
        <ProjectListTable
            onEditProject={onEditProject}
            onOpenProjectIdCard={onOpenProjectIdCard}
            onCreateProjectIdCard={onCreateProjectIdCard}
            canCreateProjectIdCard={canCreateProjectIdCard}/>
        {isAdmin && (
          <Row
            marginTop='1rem'
            justify='end'>
            <StyledActionBtn
              width='250px'
              title='Add Project'
              onClick={() =>
                setProjectModal((currentValues) => ({
                  ...currentValues,
                  isOpen: true,
                }))
              }
            />
          </Row>
        )}
      </Wrapper>
      {projectModal.isOpen && (
        <CreateEditProjectModal
          project={projectModal.project}
          onModalClose={onProjectModalClose}
          onAddProject={onAddProject}
          onUpdateProject={onUpdateProject}
          onRemoveProject={onRemoveProject}
          isAdmin={isAdmin}
        />
      )}
    </>
  );
};

export default ProjectList;
